"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
function cov_20qnpoxb6l() {
  var path = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Skeleton/lib/index.js";
  var hash = "1725e342af7ac172f266286812d79c960bf54ac9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Skeleton/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1725e342af7ac172f266286812d79c960bf54ac9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20qnpoxb6l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20qnpoxb6l();
var _default = exports.default = _Skeleton.default;